var parameterInsert={     
    IdEnterprise:'',
    ValidateExpressionRegulate:'',
    ValidateMessage:'', 
    NameExpressionRegulate:'', 
    Active:'1',
    User:'',
    IP:''
} 
var parameterUpdate={
    IdExpressionRegulate:'',
    ValidateExpressionRegulate:'',
    ValidateMessage:'', 
    NameExpressionRegulate:'', 
    Active:'1',
    User:'',
    IP:''
} 
var parameterView={  
    IdEnterprise:'',
    NameExpressionRegulate:'' 
} 
export default
{
    parameterInsert,
    parameterUpdate,
    parameterView
}